module.exports = __webpack_public_path__ + "img/in-process.b27b6880.svg";